module.exports = __webpack_public_path__ + "img/logo.6e9489fb.svg";